import React from 'react';
import PropTypes from 'prop-types';

import {
    Row,
} from '@zillow/zrs-comet';

import ConnectedInquiries from 'app/shared/components/ConnectedInquiries';
import ConnectedApplications from 'app/shared/components/ConnectedApplications';

import { StyledCol, StyledInquiriesCol } from './StyledComponents';

const ConnectedInterestedRenters = ({ updateMinModuleHeight }) => (
    <Row
        className="ConnectedInterestedRenters"
    >
        <StyledInquiriesCol
            className="Connected-Col-Temp"
            xs={12}
            lg={4}
        >
            <ConnectedInquiries updateMinModuleHeight={updateMinModuleHeight} />
        </StyledInquiriesCol>

        <StyledCol
            className="Connected-Col-Temp"
            xs={12}
            lg={8}
        >
            <ConnectedApplications updateMinModuleHeight={updateMinModuleHeight} />
        </StyledCol>
    </Row>
);

ConnectedInterestedRenters.propTypes = {
    updateMinModuleHeight: PropTypes.func,
};

ConnectedInterestedRenters.defaultProps = {
    updateMinModuleHeight: () => {},
};

export default ConnectedInterestedRenters;
